import styled from "styled-components"
import { device } from "breakpoints"

import AvenueImg from "../AvenueImg"
import { Carousel } from "../Carousel"
import {
  SlidesContainer,
  CarouselContainer,
  Slide,
  Controls,
  DotButton,
  EmblaComponent,
} from "../Carousel/style"

export const TestimonialCarousel = styled(Carousel)`
  flex-direction: column-reverse !important;
  margin: 0;
  position: relative;

  @media ${device.desktop} {
    overflow: visible !important;
  }

  ${SlidesContainer} {
    height: 615px !important;
    @media ${device.tablet} {
      height: 480px !important;
    }
    @media ${device.desktop} {
      height: 450px !important;
    }
    @media ${device.large} {
      height: 405px !important;
    }
  }

  ${EmblaComponent} {
    @media ${device.desktop} {
      overflow: visible !important;
    }
  }

  ${Controls} {
    width: 100%;
    align-items: flex-start;

    @media ${device.desktop} {
      align-items: flex-end;
      margin-right: 17%;
      position: absolute;
      top: -60px;
    }
    @media ${device.large} {
      align-items: flex-end;
    }
  }
  ${DotButton} {
    border: none;
    height: 8px !important;
    width: 8px !important;
    padding: 0;
    border-radius: 50%;
    display: inline-block;
    margin: 0 3px;
  }
`

export const Item = styled.div`
  width: 100%;
  height: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
export const TestimonialSlide = styled.div`
  font-size: 42px;
  color: #ff7f41;
  letter-spacing: -0.11px;
  line-height: 60px;

  @media ${device.desktop} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`
export const TestimonialTitle = styled.h2`
  font-size: 42px;
  color: #ff7f41;
  letter-spacing: -0.11px;
  line-height: 60px;
  margin-bottom: 15px;
  @media ${device.desktop} {
    font-size: 72px;
    letter-spacing: -0.19px;
    line-height: 92px;
    margin-bottom: 30px;
  }
`
export const TestimonialText = styled.div`
  margin-top: 10px;
  @media ${device.desktop} {
    margin-top: 0;
  }
  p {
    /* font: Source Sans Pro; */
    font-size: 16px;
    color: #3f3f3f;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 25px;

    @media ${device.desktop} {
      font-size: 20px;
      line-height: 30px;
    }
  }
`

export const TestimonialName = styled.h5`
  font-weight: 500;
  font-size: 14px;
  color: #ff7f41;
  letter-spacing: 1.56px;
  line-height: 24px;

  @media ${device.desktop} {
    font-size: 18px;
    letter-spacing: 2px;
    line-height: 36px;
  }
`

export const TestimonialPosition = styled.h6`
  font-weight: 400;
  font-size: 14px;
  color: #004e9a;
  letter-spacing: 0;
  line-height: 18px;
  text-transform: capitalize;

  @media ${device.desktop} {
    font-size: 16px;
    line-height: 24px;
  }
`

export const TestimonialLogoWrapper = styled.div`
  margin-top: 28px;
  @media ${device.desktop} {
    margin-top: 0;
    width: 28%;
    display: flex;
    justify-content: flex-end;
  }
  @media ${device.large} {
    width: 25%;
    margin-top: 0;
  }
`
export const TestimonialLogo = styled(AvenueImg)`
  width: 120px;
  height: 120px;

  @media ${device.desktop} {
    width: 260px;
    height: 260px;
  }
`

export const TestimonialDetails = styled.div`
  @media ${device.desktop} {
    width: 65%;
  }
  @media ${device.large} {
    width: 70%;
  }
`
